/** Fallback when a page has no `site` GraphQL data (e.g. default 404). Keep in sync with gatsby-config siteMetadata. */
export const SITE_DEFAULTS = {
  title: `nO EgO`,
  description: `A simple site to explore things without the ego demanding perfection decimate goodness`,
  author: `developer of no-ego.net`,
}
